// Shared by the web + native signature inputs so the two can't drift.
// Narrower than signature_pad's 0.5–2.5 defaults: the drawn stroke is baked
// into filed FA/HIPAA PDFs at small sizes, where the default max reads as a
// marker rather than a pen.
export const SIGNATURE_MIN_STROKE_WIDTH = 0.4;
export const SIGNATURE_MAX_STROKE_WIDTH = 1.6;
// Web only (react-native-signature-canvas doesn't expose it): weight of the
// velocity low-pass filter on stroke width. Slightly above the 0.7 default so
// fast strokes thin out quicker — closer to a real pen.
export const SIGNATURE_VELOCITY_FILTER_WEIGHT = 0.8;

export const SIGNATURE_CANVAS_HEIGHT = 200;
